import React from "react";
import { FaDownload } from "react-icons/fa";
import "../style/remote.css"; // Upewnij się, że plik istnieje

const Remote = () => {
  return (
    <main className="remote-container">
      <h2 className="remote-title">Pomoc zdalna</h2>
      <p className="remote-instruction">
        Aby umożliwić połączenie zdalne, prosimy o pobranie i uruchomienie aplikacji RustDesk:
      </p>

      <div className="remote-download-box">
        <p className="remote-platform">Dla systemu Windows (64-bit):</p>
        <a
          href="https://github.com/rustdesk/rustdesk/releases/download/1.4.4/rustdesk-1.4.4-x86_64.exe"
          target="_blank"
          rel="noopener noreferrer"
          className="remote-download-link"
        >
          <FaDownload className="remote-icon" />
          Pobierz RustDesk
        </a>
      </div>
    </main>
  );
};

export default Remote;
